import React, { useEffect, useState } from 'react';
import "bootstrap/dist/js/bootstrap.bundle.min";
import { Link } from 'react-router-dom';
import { FaTooth, FaUserMd, FaCalendarCheck, FaPhone, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import './Home.css';
import CountUp from "react-countup";
import AddAppointment from './AddAppointment';
import DentalExpertise from './DentalExpertise';
import DentalExpertiseTwo from './DentalExpertiseTwo';
import VisitOurBeehive from './VisitOurBeehive';
import DentalGallerySlider from './DentalGallerySlider';
import WhatWeDoBest from './WhatWeDoBest';

// Import assets from your local folder
import heroVideo from "./assets/video-1.mp4";
import aboutImg from "./assets/image-5.jpg";
import stethoscope from "./assets/dental-intrument.jpg";
import doctorsPatient from "./assets/doctors-patient.png";

const Home = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        // Initialize Bootstrap components
        const script = document.createElement('script');
        script.src = "https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js";
        script.async = true;
        document.body.appendChild(script);
    }, []);

    const services = [
        {
            id: 1,
            title: "Zero Data Collection",
            description: "We do not collect, store, or share any personal information while you browse our website. Complete privacy protection.",
            icon: <FaTooth />
        },
        {
            id: 2,
            title: "Cookie-Free Browsing",
            description: "Enjoy a completely tracking-free experience with no analytics scripts or digital fingerprinting technologies.",
            icon: <FaTooth />
        },
        {
            id: 3,
            title: "GDPR & CCPA Compliance",
            description: "Fully compliant with global data protection regulations. Your privacy rights are always respected and protected.",
            icon: <FaTooth />
        },
        {
            id: 4,
            title: "No Third-Party Tracking",
            description: "Zero external trackers, pixels, or analytics. Browse with confidence knowing your data stays private.",
            icon: <FaTooth />
        }
    ];

    const testimonials = [
        { id: 1, name: "Faisal Zahid", text: "Best dental experience I've ever had. The staff is friendly and professional.", rating: 5 },
        { id: 2, name: "Muhammad Wahid", text: "Dr. Atif Paracha and his team are amazing. They made me feel comfortable throughout.", rating: 5 },
        { id: 3, name: "Asiya", text: "Modern facility with state-of-the-art equipment. Highly recommended!", rating: 5 }
    ];

    const handleOpenModal = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
        setRefreshKey(prev => prev + 1);
    };

    const handleSaveAppointment = () => {
        // Appointment saved successfully
        alert('Appointment booked successfully!');
    };

    return (
        <>
            {/* Hero Section with Video Background */}
            <section className="hero-section">
                <div className="video-container">
                    <video autoPlay loop muted playsInline className="hero-video">
                        <source src={heroVideo} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                    <div className="video-overlay"></div>
                </div>
                <div className="hero-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8 mx-auto text-center">
                                <h1 className="hero-title">Welcome to Paracha Dental Care</h1>
                                <p className="hero-subtitle">Your smile is our priority. Experience exceptional dental care in a comfortable and welcoming environment.</p>
                                <button onClick={handleOpenModal} className="btn btn-primary btn-lg me-3">Book Appointment</button>
                                <Link to="/services" className="btn btn-outline-light btn-lg">Our Services</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Appointment Section */}
            <section className="appointment-section py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6 mb-4">
                            <div className="border-frame red-frame">
                                <div className="inner-box">
                                    <h6 className="small-title">GET IN</h6>
                                    <h2 className="main-title">CONTACT</h2>
                                    <div className="contact-info">
                                        <div className="contact-item">
                                            <i className="fas fa-phone-alt"></i>
                                            <div>
                                                <h4>Morning Timing:</h4>
                                                <p>Monday - Thursday</p>
                                                <p>10:30 AM - 12:30 PM</p>
                                            </div>
                                        </div>
                                        <div className="contact-item">
                                            <i className="fas fa-phone-alt"></i>
                                            <div>
                                                <h4>Evening Timing:</h4>
                                                <p>Monday - Saturday</p>
                                                <p>06:30 PM - 8:30 PM</p>
                                            </div>
                                        </div>
                                        <div className="contact-item">
                                            <i className="fas fa-phone-alt"></i>
                                            <div>
                                                <p>Sunday: Closed</p>
                                            </div>
                                        </div>                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="border-frame blue-frame">
                                <div className="inner-box">
                                    <h6 className="small-title">COMMON</h6>
                                    <h2 className="main-title">QUESTIONS</h2>
                                    <div className="faq-list">
                                        <details className="faq-item">
                                            <summary>What services do you offer?</summary>
                                            <p>We offer professional services tailored to your needs.</p>
                                        </details>
                                        <details className="faq-item">
                                            <summary>Do you offer remote consultations?</summary>
                                            <p>Yes, we provide virtual consultations upon request.</p>
                                        </details>
                                        <details className="faq-item">
                                            <summary>What's your response time?</summary>
                                            <p>We typically respond within 24 hours.</p>
                                        </details>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Info Bar */}
            <section className="info-bar">
                <div className="container">
                    <div className="row">

                        <div className="col-4">
                            <div className="info-item">
                                <FaPhone className="info-icon" />
                                <div>
                                    <h4>Call Us</h4>
                                    <p>+92 300 257 3177</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-4">
                            <div className="info-item">
                                <FaMapMarkerAlt className="info-icon" />
                                <div>
                                    <h4>Location</h4>
                                    <p>Gulshan-e-Iqbal, Karachi</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-4">
                            <div className="info-item">
                                <FaClock className="info-icon" />
                                <div>
                                    <h4>Working Hours</h4>
                                    <p>Mon-Fri: 9am - 6pm</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            {/* About Section */}
            {/*             
            <section className="about-section">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="about-content">
                                <h2 className="section-title">About Paracha Dental Care</h2>
                                <p className="section-subtitle">Your Trusted Dental Partners</p>
                                <p className="about-text">At Paracha Dental Care, we believe that everyone deserves a healthy, beautiful smile. Our team of experienced professionals is dedicated to providing the highest quality dental care in a comfortable and welcoming environment.</p>
                                <p className="about-text">With state-of-the-art technology and a patient-centered approach, we offer comprehensive dental services for the whole family.</p>
                                <div className="about-features">
                                    <div className="feature"><FaUserMd className="feature-icon" /><span>Experienced Doctors</span></div>
                                    <div className="feature"><FaTooth className="feature-icon" /><span>Modern Equipment</span></div>
                                    <div className="feature"><FaCalendarCheck className="feature-icon" /><span>Flexible Scheduling</span></div>
                                </div>
                                <Link to="/about" className="btn btn-primary mt-4">Learn More About Us</Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="about-image">
                                <img src={aboutImg} alt="Dental Office" className="img-fluid rounded" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
*/}

            <DentalExpertise />

            <VisitOurBeehive />

            {/* Services Section */}
            <section className="services-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="section-title">Our Privacy Guarantees</h2>
                        <p className="section-subtitle">Your Data Protection Promise</p>
                    </div>
                    <div className="row">
                        {services.map(service => (
                            <div className="col-lg-3 col-md-6 mb-4" key={service.id}>
                                <div className="service-card">
                                    <div className="service-icon">{service.icon}</div>
                                    <h3 className="service-title">{service.title}</h3>
                                    <p className="service-description">{service.description}</p>
                                    <Link to={`/services/${service.id}`} className="service-link">Learn More →</Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <WhatWeDoBest />

            {/* Gallery Section */}

            <DentalGallerySlider />

            {/* Testimonials Section */}
            <section className="testimonials-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <h2 className="section-title text-white">What Our Patients Say</h2>
                        <p className="section-subtitle text-white-50">Real Stories from Happy Patients</p>
                    </div>
                    <div className="row">
                        {testimonials.map(testimonial => (
                            <div className="col-md-4 mb-4" key={testimonial.id}>
                                <div className="testimonial-card">
                                    <div className="testimonial-rating">{'★'.repeat(testimonial.rating)}{'☆'.repeat(5 - testimonial.rating)}</div>
                                    <p className="testimonial-text">"{testimonial.text}"</p>
                                    <h4 className="testimonial-name">{testimonial.name}</h4>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* CTA Section */}
            <section className="cta-section">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-8 mx-auto text-center">
                            <h2 className="cta-title">Ready to Transform Your Smile?</h2>
                            <p className="cta-text">Book your appointment today and take the first step towards a healthier, more beautiful smile.</p>
                            <button onClick={handleOpenModal} className="btn btn-light btn-lg"><FaCalendarCheck className="me-2" />Schedule Your Visit</button>
                        </div>
                    </div>
                </div>
            </section>

            {/* Add Appointment Modal */}
            <AddAppointment
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onSave={handleSaveAppointment}
                appointmentToEdit={null}
            />
        </>
    );
};

export default Home;